import api from '@/libs/axiosInstance';
import type { AgentSettings, ApiResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

/**
 * fetches the brand's per-brand agent toggles + remaining monthly
 * budget. The endpoint synthesizes a default record on first read so we never
 * need a 404 fallback in the UI.
 */
const fetchAgentSettings = async (brandId: string): Promise<AgentSettings> => {
  const { data } = await api.get<ApiResponse<AgentSettings>>(
    `/dashboard/brands/${brandId}/agent-settings`
  );
  return data.data as AgentSettings;
};

export const useAgentSettingsQuery = (brandId: string) => {
  return useQuery<AgentSettings, Error>({
    queryKey: ['agentSettings', brandId],
    queryFn: () => fetchAgentSettings(brandId),
    enabled: !!brandId,
  });
};
